module.exports = __webpack_public_path__ + "img/img-1.bbfd302e.webp";